import { useState } from 'react';

// Only presentation preferences are stored; never report records or user data.
export function useReportPreference(key, fallback, sharedValue) {
  const storageKey = `report-ui:v1:${window.location.pathname}:${key}`;
  const initial = () => typeof fallback === 'function' ? fallback() : fallback;
  const [value, setValue] = useState(() => {
    if (sharedValue !== undefined) return sharedValue;
    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey));
      return saved !== null && typeof saved === typeof initial() ? saved : initial();
    } catch { return initial(); }
  });
  const update = next => setValue(previous => {
    const resolved = typeof next === 'function' ? next(previous) : next;
    try { sessionStorage.setItem(storageKey, JSON.stringify(resolved)); } catch { /* Storage can be unavailable. */ }
    return resolved;
  });
  return [value, update];
}
